import { VCSLevelModel } from "@/models/title-list-model";
import { sortBy } from "lodash";
import { store } from "@/commonui/store/index";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { UnitListManagerService } from "@/services/text-guardian/unit-list";
import {
	ObjectiveService,
	UnitobjectiverelatedModel,
	RelatedContentModel,
	UnitobjectiverelatedwithparentModel
} from "@/services/objective-manager";
import { ObjectiveActionType } from "@/util/enum";
import { TitleListService } from "@/services/title-list-service";

@Module({ namespaced: true, name: "ObjectiveState", store: store, dynamic: true })
class ObjectiveState extends VuexModule {
	unitService = UnitListManagerService();
	isLevel3Selected: boolean = false;
	vcsUnits: VCSLevelModel[] = [];
	relatedContents: RelatedContentModel[] = [];
	unitobjectiverelated: UnitobjectiverelatedModel[] = [];
	parentunitobjectiverelated: UnitobjectiverelatedModel[] = [];
	ownunitobjectiverelated: UnitobjectiverelatedModel[] = [];
	currentActionType: ObjectiveActionType = ObjectiveActionType.New;

	@Mutation
	setVCSLevelUnits(units: VCSLevelModel[]) {
		this.vcsUnits = units;
	}

	@Mutation
	setLevel3Selected(isSelected: boolean) {
		this.isLevel3Selected = isSelected;
	}

	@Mutation
	async setUnitobjectiverelated(value) {
		this.unitobjectiverelated = sortBy(value, "unit.unit");
	}

	@Mutation
	async setParentUnitobjectiverelated(value) {
		this.parentunitobjectiverelated = sortBy(value, "unit.unit");
	}

	@Mutation
	async setOwnUnitobjectiverelated(value) {
		this.ownunitobjectiverelated = value;
	}

	@Mutation
	async setRelatedContents(value) {
		this.relatedContents = value;
	}

	@Mutation
	setCurrentActionType(value) {
		this.currentActionType = value;
	}

	@Action
	async getVCSLevelUnits() {
		const units = await TitleListService.getLevels([], true);
		this.setVCSLevelUnits(units);
	}

	@Action
	async getUnitobjectiverelated(item) {
		const params = {
			objectiveId: item && item.id
		};
		const objectiverelated = await ObjectiveService.getUnitobjectiverelated(params);
		this.setUnitobjectiverelated(objectiverelated);
	}

	@Action
	async getUnitobjectiverelatedwithparent(item) {
		let params = {};
		if (item && item.isObjectiveIdNew) {
			params = {
				parentObjectiveId: item && item.id // sending id of level 3
			};
		} else {
			params = {
				objectiveId: item.id,
				parentObjectiveId: item && item.parentId
			};
		}

		const objectiverelated = await ObjectiveService.getUnitObjectiveRelatedWithParent(params);
		this.setRelatedContents(objectiverelated.relatedContent);
		this.setParentUnitobjectiverelated(objectiverelated.parentUnitObjective);
		this.setOwnUnitobjectiverelated(objectiverelated.unitObjective);
	}

	@Action
	async getRelatedContents(item) {
		const params = {
			objectiveId: item && item.id
		};
		const relatedContents = await ObjectiveService.getRelatedContents(params);
		this.setRelatedContents(relatedContents);
	}

	@Action
	async swapingTreeNodes(nodes) {
		const params = {
			preObjectiveId: nodes.preId,
			nextObjectiveId: nodes.curId,
			swappedObjectiveId: nodes.swappedId
		};
		return await ObjectiveService.swapingTreeNodes(params);
	}
}

export const ObjectiveModule = getModule(ObjectiveState);
